export const INCH = 0.0254; // 1 inch in meters
export const M_TO_FT = 3.28084;

export function formatFtInShort(meters) {
  const totalInches = Math.round(meters / INCH);
  const ft = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return inches === 0 ? `${ft} ft.` : `${ft} ft. ${inches} in.`;
}

export function formatFtInSymbol(meters) {
  const totalInches = Math.round(meters / INCH);
  const ft = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return inches === 0 ? `${ft}'` : `${ft}' ${inches}"`;
}
